import { render } from "./ErrorBox.vue?vue&type=template&id=2a5a8b56&scoped=true"
import script from "./ErrorBox.vue?vue&type=script&lang=js"
export * from "./ErrorBox.vue?vue&type=script&lang=js"

import "./ErrorBox.vue?vue&type=style&index=0&id=2a5a8b56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5a8b56"]])

export default __exports__